const PbxxRecord = require('../../pbxx_record')

module.exports = class CampaignImpressions extends PbxxRecord {
  static get class_name() {
    return 'CampaignImpressions'
  }
}
